import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import objects from './objects'
import knowledgeBase from './knowledgeBase'
import apartments from './apartments'
import breadcrumb from './breadcrumb'
import sections from './sections'
import flats from './flats'
import stages from './stages'
import files from './files'
import users from './users'
import clients from './clients'
import kanban from './kanban'
import sms from './sms'
import contracts from './contracts'
import finance from './finance'
import administration from './administration'
import permission from './permission'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    objects,
    knowledgeBase,
    apartments,
    breadcrumb,
    sections,
    flats,
    stages,
    files,
    users,
    clients,
    kanban,
    sms,
    contracts,
    finance,
    administration,
    permission
  },
  strict: process.env.DEV,
})